import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SearchTeamList } from "../../../model/branch/BranchTeamModel";
import { SearchChatsList } from "../../../model/branch/BranchChatsModel";
import { ProfileList } from "../../../model/search/SearchProfileListModel";
import { GroupInfoMember } from "../../../model/chats/GroupChatInfoModel";

interface ModalInterface {
  timestamp: number;
  detailTeam: SearchTeamList | null;
  detailSearchTeam: ProfileList | null;
  detailChatGroupTeam: GroupInfoMember | null;
  detailDeptChat: SearchChatsList | null;
}

const initialState: ModalInterface = {
  timestamp: Date.now(),
  detailTeam: null,
  detailSearchTeam: null,
  detailChatGroupTeam: null,
  detailDeptChat: null,
};

const detailConnectDeptTeamSlice = createSlice({
  name: "detailconnectdeptchat",
  initialState,
  reducers: {
    updateTimestamp: (state) => {
      state.timestamp = Date.now();
    },
    updateTeam: (state, action: PayloadAction<SearchTeamList>) => {
      state.detailTeam = action.payload;
      state.detailSearchTeam = null;
      state.detailChatGroupTeam = null;
    },
    updateSearchTeam: (state, action: PayloadAction<ProfileList>) => {
      state.detailSearchTeam = action.payload;
      state.detailChatGroupTeam = null;
      state.detailTeam = null;
    },
    updateChatGroupTeam: (state, action: PayloadAction<GroupInfoMember>) => {
      state.detailChatGroupTeam = action.payload;
      state.detailSearchTeam = null;
      state.detailTeam = null;
    },
    updateDeptChat: (state, action: PayloadAction<SearchChatsList>) => {
      state.detailDeptChat = action.payload;
    },
  },
});

export const {
  updateTeam,
  updateDeptChat,
  updateSearchTeam,
  updateChatGroupTeam,
} = detailConnectDeptTeamSlice.actions;

export default detailConnectDeptTeamSlice.reducer;
